import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Owner } from '../../helpers/owner.decorator';

@Owner('Stat-Force 1')
@Component({
    selector: 'nova-wfd-returner-chip',
    standalone: true,
    imports: [MatChipsModule, MatIconModule, MatTooltipModule, NgClass],
    template: `
        <mat-chip
            [ngClass]="isCompact ? 'compact' : ''"
            color="info"
            data-qa-id="wfd-returner-priority"
            [disabled]="isDisabled"
            [matTooltipHideDelay]="hideDelay"
            [matTooltip]="tooltipText"
            [matTooltipDisabled]="tooltipDisabled"
            matTooltipPosition="above">
            <mat-icon matChipAvatar>assignment_return</mat-icon>
            Returner
        </mat-chip>
    `,
    styleUrls: ['./chip.component.scss']
})
export class WfdReturnerChipComponent {
    @Input() isDisabled = false;
    @Input() isCompact = false;
    @Input() tooltipText = 'Candidate has previously worked a WFD job';
    @Input() tooltipDisabled = false;
    @Input() hideDelay = 500;
}
